import $ from 'jquery'

export default {

    data: function () {
        var session_userid;
        var gid = this.$route.params.gid;

        if(this.isLogin()){
            session_userid = this.getSessionProc().coEmailId
        }else{
            session_userid = ''
        }

        var wishCount = 0 ;
        return {
            gid,
            session_userid,
            wishCount,

        }
    },

    updated: function () {

        var self = this
        // setTimeout(function () {

        self.getWishLike( self.gid, self.session_userid );
        // }, 10000)

    },


    methods: {



        getWishLike: function ( _gid, _userId ) {

            this.axiosCaller.get( this,  this.APIs.MINE + "/wish", {
                gid: _gid,
                coEmailId: _userId
            },(result) => {
                var data = result.data;
                console.log("== getWishLike ==")

                if ( data.status == "ok" ) {

                    console.log(data)
                    this.wishCount = data.wishCount;
                    data.wishList.forEach(wish => {
                        $('#eWish-' + wish.gid).addClass("active");
                    })

                } else {
                    console.log(data.msg)
                }

            })

        },


        setWish: function (e) {
            // this.gid = e.target.getAttribute("data-gid");
            var userId = this.session_userid;

            if ( !e.target.classList.contains("active") ) {
                this.putWish( this.gid, userId );
                e.target.classList.add("active");
                this.swalUtils.gritter( "관심상품", "관심상품으로 등록되었습니다.", "info", 800 )
            } else {
                this.deleteWish( this.gid, userId );
                e.target.classList.remove("active");
                this.swalUtils.gritter( "관심상품", "관심상품이 해제되었습니다.", "info", 800 )
            }

        },

        getWish: function ( _userId ) {

            this.axiosCaller.get( this,  this.APIs.MINE + "/wish", {
                coEmailId: _userId
            }, (res) => {

                var data = res.data;

                console.log("== getWish ==")
                console.log(data)

            })

        },

        putWish: function ( _gid, _userId ) {

            console.log(_gid, _userId)
            this.axiosCaller.post( this,  this.APIs.MINE + "/setWish", {
                gid: _gid,
                coEmailId: _userId
            }, (res) => {

                var data = res.data;

                console.log("== putWish ==")
                if ( data.status == "ok" ) {
                    this.wishCount = data.wishCount;
                } else {
                    console.log(data.msg)
                }

            })

        },


        deleteWish: function ( _gid, _userId ) {
            // $http.delete( $apis.eduMine + "/like", {
            console.log(_gid, _userId)
            this.axiosCaller.post( this,  this.APIs.MINE + "/wish", {
                gid: _gid,
                coEmailId: _userId
            }, (res) => {
                var data = res.data;

                console.log("== deleteWish ==")
                if ( data.status == "ok" ) {
                    console.log(data)
                    this.wishCount = res.data.wishCount;
                } else {
                    console.log(data.msg)
                }

            })

        },



    },


};